export default {"src":"/_next/static/media/advantages-icon-5.89947e10.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};